import React from "react";
import { Row, Col, Form, Select, Button, DatePicker } from "antd";

const { RangePicker } = DatePicker;

const FilterBar = ({ stores, loading, onSubmit, onExport = () => {} }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const { storeName, dateRange } = values;

    const [startDate, endDate] = dateRange || [];

    onSubmit({
      storeName: storeName || null,
      dateRange: [
        startDate ? startDate.startOf("day").format("YYYY-MM-DD HH:mm:ss") : null,
        endDate ? endDate.endOf("day").format("YYYY-MM-DD HH:mm:ss") : null,
      ],
    });
  };

  return (
    <Row
      gutter={8}
      style={{
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 24,
        paddingBottom: 10,
      }}
    >
      <Col className="gutter-row" xs={24}>
        <Form form={form} onFinish={handleFinish}>
          <Row gutter={8}>
            <Col span={24}>
              <h4>Search</h4>
            </Col>

            <Col xs={24} md={6} lg={6} xxl={6}>
              <Form.Item name="storeName">
                <Select
                  showSearch
                  allowClear
                  options={stores}
                  placeholder="All Merchants"
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={10} lg={10} xxl={10}>
              <Form.Item name="dateRange">
                <RangePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>

            <Col xs={0} md={8} lg={8} xxl={8} />

            <Col span={5}>
              <Form.Item style={{ marginTop: 8 }}>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Form.Item style={{ marginTop: 8 }}>
              <Button
                block
                type="default"
                onClick={() => onExport?.()}
              >
                Export CSV
              </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default FilterBar;
